__turbopack_context__.v({
  "body": "popup-message-module__7NLk3q__body",
  "close": "popup-message-module__7NLk3q__close",
  "content": "popup-message-module__7NLk3q__content",
  "continue": "popup-message-module__7NLk3q__continue",
  "dialog": "popup-message-module__7NLk3q__dialog",
  "paper": "popup-message-module__7NLk3q__paper",
  "signature": "popup-message-module__7NLk3q__signature",
  "stub": "popup-message-module__7NLk3q__stub",
  "ticket": "popup-message-module__7NLk3q__ticket",
  "title": "popup-message-module__7NLk3q__title",
});
